class InfoModal extends HTMLElement {
  constructor() {
    super();
    this.triggerButtons = Array.from(
      document.querySelectorAll(`a[href]:not([href="#"])`)
    ).filter((a) => a.href.includes("#"));
    this.closeButtons = this.querySelectorAll(".info-modal__button");
    this.productInfoWrap = document.querySelector(".product__info-container");

    this.triggerButtons.forEach((button) =>
      button.addEventListener("click", () => {
        const hash = button.getAttribute("href").replace("#", "");
        this.open(hash);
      })
    );

    if (window.location.hash) {
      const hash = window.location.hash.replace("#", "");
      this.open(hash);
    }

    console.log("this.closeButtons", this);

    this.closeButtons.forEach((button) =>
      button.addEventListener("click", this.close.bind(this))
    );
  }

  connectedCallback() {}
  open(id) {
    const popup = document.querySelector(`#modal-${id}`);
    if (popup) {
      popup.classList.add("is-open");
      if (this.productInfoWrap)
        this.productInfoWrap.classList.add("change-height");
    }
  }
  close() {
    this.classList.remove("is-open");
    if (this.productInfoWrap)
      this.productInfoWrap.classList.remove("change-height");
    history.replaceState(null, null, " ");
  }
}

customElements.define("info-modal", InfoModal);
